export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";